import { render } from "./Requestbox.vue?vue&type=template&id=47482e85&scoped=true&ts=true"
import script from "./Requestbox.vue?vue&type=script&lang=ts"
export * from "./Requestbox.vue?vue&type=script&lang=ts"

import "./Requestbox.vue?vue&type=style&index=0&id=47482e85&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47482e85"]])

export default __exports__